/** 將 API 回傳的 /api/v1/uploads/… 轉成 CRM 同域可載入的完整 URL */
export function crmUploadUrl(fileUrl: string | null | undefined): string | undefined {
  if (!fileUrl?.trim()) return undefined;
  let path = fileUrl.trim().replace(/\\/g, '/');
  if (/^https?:\/\//i.test(path)) return path;
  const uploadsTail = path.match(/\/uploads\/([^/?#]+)$/i);
  if (uploadsTail?.[1]) {
    path = `/api/v1/uploads/${uploadsTail[1]}`;
  } else if (!path.startsWith('/api/v1/uploads/')) {
    const base = path.split('/').pop();
    if (base) path = `/api/v1/uploads/${base}`;
  }
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
}
